import mealIcon from '../../assets/icons/v3/flexible-remuneration/activity_meal.svg?url';
import nurseryIcon from '../../assets/icons/v3/flexible-remuneration/rf_children.svg?url';
import transportIcon from '../../assets/icons/v3/flexible-remuneration/rf_transportation.svg?url';
import trainingIcon from '../../assets/icons/v3/flexible-remuneration/wellbeing_education.svg?url';
import healthIcon from '../../assets/icons/v3/flexible-remuneration/wellbeing_medicine.svg?url';
import { TRANSLATIONS_HOME } from '../translations/home';

export const BETTERFLY_SPAIN_BANK_DATA = {
  holder: 'Betterfly Operating España SLU',
  bank: 'SWAN',
  iban: 'FR76 1732 8844 0026 3184 0062 230',
  swift: 'SWNBFR22'
};

export const COPY_BETTERFLY_SPAIN_BANK_DATA = [
  BETTERFLY_SPAIN_BANK_DATA.holder,
  BETTERFLY_SPAIN_BANK_DATA.bank,
  BETTERFLY_SPAIN_BANK_DATA.iban,
  BETTERFLY_SPAIN_BANK_DATA.swift
].join('\n');

export const FLEXIBLE_REMUNERATION_BENEFITS = {
  'flexible-remuneration-meal': {
    title: TRANSLATIONS_HOME.expensesCard.categories.restaurant,
    icon: mealIcon
  },
  'flexible-remuneration-transport': {
    title: TRANSLATIONS_HOME.expensesCard.categories.transport,
    icon: transportIcon
  },
  'flexible-remuneration-health': {
    title: TRANSLATIONS_HOME.expensesCard.categories.healthInsurance,
    icon: healthIcon
  },
  'flexible-remuneration-nursery': {
    title: TRANSLATIONS_HOME.expensesCard.categories.daycare,
    icon: nurseryIcon
  },
  'flexible-remuneration-training': {
    title: TRANSLATIONS_HOME.expensesCard.categories.learning,
    icon: trainingIcon
  }
};
